import ItemModel from "./ItemModel";

export default class ItemGroupModel {
	constructor(data?: any) {
		if (data) {
			this.id = data.id;
			this.name = data.name;
			this.description = data.description;
			this.parentGroupId = data.parentGroupId;
		}
	}

	id = 0;
	name = "";
	description: string | null = null;
	parentGroupId: number | null = null;
	children: Array<ItemGroupModel> | null = null;	
	components: Array<ItemModel> | null = null;	
}